// eslint-disable-next-line import/no-mutable-exports
var config;
// eslint-disable-next-line import/no-mutable-exports
var authenticationHandler;
export function setConfig(newConfig) {
    config = newConfig;
}
export function setAuthenticationHandler(ovpAuthenticationHandler) {
    authenticationHandler = ovpAuthenticationHandler;
}
export { config, authenticationHandler };
//# sourceMappingURL=playback-config-storage.js.map